// LoginPage.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Layout, Card, Button, Typography, Space, Divider } from 'antd';
import { 
  GoogleOutlined, 
  WindowsOutlined,
  MessageOutlined
} from '@ant-design/icons';

const { Header, Content, Footer } = Layout;
const { Title, Text } = Typography;

function LoginPage() {
  const { t, i18n } = useTranslation();
  const handleLogin = (provider) => {
    window.location.href = `/auth/${provider}`;
  };

  const loginButtons = [
    {
      key: 'google',
      icon: <GoogleOutlined />,
      text: t('login.google'),
      color: '#DB4437',
      provider: 'google'
    },
    {
      key: 'microsoft',
      icon: <WindowsOutlined />,
      text: t('login.microsoft'),
      color: '#00A4EF',
      provider: 'microsoft'
    },
    {
      key: 'discord',
      icon: <MessageOutlined />,
      text: t('login.discord'),
      color: '#7289DA',
      provider: 'discord'
    }
  ];

  return (
    <Layout style={{ minHeight: '100vh', background: '#f0f2f5' }}>
      <Header className="landing-header" style={{position:'fixed',width:'100%',zIndex:1}}>
        <div className="container header-inner">
          <div className="logo" onClick={()=>window.location.href='/'}>LOGO</div>
          <div className="right-actions">
            <select value={i18n.language} onChange={e=>i18n.changeLanguage(e.target.value)} className="lang-select">
              <option value="en">EN</option>
              <option value="zh-CN">简体</option>
              <option value="zh-TW">繁體</option>
              <option value="ja">日本語</option>
            </select>
          </div>
        </div>
      </Header>

      <Content style={{ 
        marginTop: 64,
        padding: '50px 20px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <Card 
          style={{ 
            width: '100%',
            maxWidth: 400,
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
            borderRadius: '8px'
          }}
          bordered={false}
        >
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <Title level={2}>{t('login.welcome')}</Title>
            <Text type="secondary">
              {t('login.chooseMethod')}
            </Text>
          </div>

          <Divider />

          <Space direction="vertical" size="large" style={{ width: '100%' }}>
            {loginButtons.map(({ key, icon, text, color, provider }) => (
              <Button
                key={key}
                size="large"
                icon={icon}
                onClick={() => handleLogin(provider)}
                style={{
                  width: '100%',
                  height: '50px',
                  background: color,
                  borderColor: color,
                  color: '#fff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.opacity = '0.9';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.opacity = '1';
                }}
              >
                {text}
              </Button>
            ))}
          </Space>

          <div style={{ marginTop: '24px', textAlign: 'center' }}>
            <Text type="secondary">
              {t('login.agree1')}
              <Button type="link">{t('login.terms')}</Button>
              {t('login.and')}
              <Button type="link">{t('login.privacy')}</Button>
            </Text>
          </div>
        </Card>
      </Content>

      <Footer style={{ 
        textAlign: 'center',
        background: 'transparent'
      }}>
        <Text type="secondary">©2025 Koepo</Text>
      </Footer>
    </Layout>
  );
}

export default LoginPage;

// 添加自定义样式
const styles = {
  '@keyframes fadeIn': {
    from: { opacity: 0, transform: 'translateY(20px)' },
    to: { opacity: 1, transform: 'translateY(0)' }
  },
  '.login-card': {
    animation: 'fadeIn 0.5s ease-out'
  }
};

// 将样式添加到文档中
const styleSheet = document.createElement('style');
styleSheet.textContent = Object.entries(styles).map(([selector, rules]) => {
  if (selector.startsWith('@')) {
    return `${selector} ${JSON.stringify(rules)
      .replace(/[{"}]/g, '')
      .replace(/,/g, ';')}`;
  }
  return `${selector} ${JSON.stringify(rules)
    .replace(/[{"}]/g, '')
    .replace(/,/g, ';')}`;
}).join('\n');
document.head.appendChild(styleSheet);
